import { isExperienceStore } from '@util'

export const TAB_UPDATE_RECORD = '0' //更新记录
export const TAB_CONTACT = '1' //联系
export const TAB_SIGN = '2' //签单
export const TAB_TASK = '3' //任务

// 任务类型，1-回访任务，2-预约到店，3-事项提醒
export const TASK_TYPE_BACK = '1'
export const TASK_TYPE_APPO = '2'
export const TASK_TYPE_EVENT = '3'

// 任务状态 1-待完成，2-已完成，3-已过期
export const TASK_STATUS_TODO = '1'
export const TASK_STATUS_DONE = '2'
export const TASK_STATUS_EXPIRED = '3'

export const TASK_STATUS_MAPPING = {
  [TASK_STATUS_TODO]: '待完成',
  [TASK_STATUS_DONE]: '已完成',
  [TASK_STATUS_EXPIRED]: '已过期'
}

// 沟通方式：1-到店，2-电话，3-微信，4-私信，5-其他
export const CONTACT_ARRI = '1'
export const CONTACT_MOBILE = '2'
export const CONTACT_WECAHT = '3'
export const CONTACT_PRIVATE_CHAT = '4'
export const CONTACT_OTHER = '5'

// 来源 15-门店·直接到店，16-门店·客人转介绍，17-门店·员工转介绍，18-门店·其他
export const SOURCE_SELF = '15'
export const SOURCE_CUSTOMER = '16'
export const SOURCE_STUFF = '17'
export const SOURCE_STORE = '18'

export const SOURCE_LIST = [
  {
    id: '15',
    title: '门店·直接到店'
  },
  {
    id: '16',
    title: '门店·客人转介绍'
  },
  {
    id: '17',
    title: '门店·员工转介绍'
  },
  {
    id: '18',
    title: '门店·其他'
  }
]

//跟进状态，1跟进中，0不再跟进
export const FOLLOW_STATUS_ING = '1'
export const FOLLOW_STATUS_NOT = '0'

export const getDateTypeList = () => {
  const base = [
    {
      title: '创建时间',
      value: 'created_at'
    },
    {
      title: '婚期',
      value: 'weddingday'
    },
    {
      title: '更新时间',
      value: 'order_at'
    },
    {
      title: '到店时间',
      value: 'arrive_at'
    },
    {
      title: '签单时间',
      value: 'sign_at'
    }
  ]

  if (isExperienceStore()) {
    base.push({
      title: '派单时间',
      value: 'adv_time'
    })
  }

  return base
}

// 加盟店 0-全部，1-沟通，2--到店，3-签单，4-完成服务，100婚期已过，101不再跟进（多选，逗号隔开）
export const FRANCHISE_STATUS_ING = '1'
export const FRANCHISE_STATUS_ARRIVE = '2'
export const FRANCHISE_STATUS_SIGN = '3'
export const FRANCHISE_STATUS_DONE = '4'
export const FRANCHISE_STATUS_PASSED = '100'
export const FRANCHISE_STATUS_NOT_FOLLOW = '101'

export const FRANCHISE_STATUS_LIST = [
  {
    title: '沟通',
    value: FRANCHISE_STATUS_ING
  },
  {
    title: '到店',
    value: FRANCHISE_STATUS_ARRIVE
  },
  {
    title: '签单',
    value: FRANCHISE_STATUS_SIGN
  },
  {
    title: '完成服务',
    value: FRANCHISE_STATUS_DONE
  },
  {
    title: '婚期已过',
    value: FRANCHISE_STATUS_PASSED
  },
  {
    title: '不再跟进',
    value: FRANCHISE_STATUS_NOT_FOLLOW
  }
]

export const PROPERTY_WITH_WEDDING = [
  { id: '2', name: '婚礼策划' },
  { id: '6', name: '婚纱摄影' },
  { id: '7', name: '婚礼摄影' },
  { id: '8', name: '婚礼摄像' },
  { id: '9', name: '婚礼跟妆' },
  { id: '11', name: '婚礼司仪' },
  { id: '12', name: '婚纱礼服' },
  { id: '13', name: '婚宴酒店' },
  { id: '14', name: '婚戒首饰' },
  { id: '15', name: '花艺甜品' },
  { id: '1000', name: '婚品' },
  { id: '1001', name: '婚车' }
]

export const PROPERTY_WITH_WEDDING_OBJ = {
  '2': '婚礼策划',
  '6': '婚纱摄影',
  '7': '婚礼摄影',
  '8': '婚礼摄像',
  '9': '婚礼跟妆',
  '11': '婚礼司仪',
  '12': '婚纱礼服',
  '13': '婚宴酒店',
  '14': '婚戒首饰',
  '15': '花艺甜品',
  '1000': '婚品',
  '1001': '婚车'
}

export const PROPERTY_EXPERIENCE_LIST = [
  { id: '2', name: '婚礼策划' },
  { id: '6', name: '婚纱摄影' },
  { id: '7', name: '婚礼摄影' },
  { id: '8', name: '婚礼摄像' },
  { id: '9', name: '婚礼跟妆' },
  { id: '11', name: '婚礼司仪' },
  { id: '12', name: '婚纱礼服' },
  { id: '14', name: '婚戒首饰' },
  { id: '15', name: '花艺甜品' }
]

export const CHARGE_STATUS_SUCCESS = '1'
export const CHARGE_STATUS_FAILED = '2'

// 扣款状态
export const CHARGE_STATUS = {
  '0': '扣款审批中',
  [CHARGE_STATUS_SUCCESS]: '扣款成功',
  [CHARGE_STATUS_FAILED]: '扣款审批不通过'
}

export const REFUND_STATUS_NOT_APPLY = '0'
export const REFUND_STATUS_VERIFYING = '1'
export const REFUND_STATUS_SUCCESS = '2'
export const REFUND_STATUS_FAILED = '3'

// 退款状态
export const REFUND_STATUS = {
  [REFUND_STATUS_NOT_APPLY]: '未申请退款',
  [REFUND_STATUS_VERIFYING]: '退款审批中',
  [REFUND_STATUS_SUCCESS]: '退款成功',
  [REFUND_STATUS_FAILED]: '退款审批失败'
}

export const STATUS_COLOR = (status, refund_status) => {
  let color = ''

  if (status == 2 || refund_status == 3) {
    color = '#FF801A'
  } else if (status == 0 || refund_status == 1) {
    color = '#448AFC'
  } else {
    color = '#47D788'
  }
  return color
}
